/**
 * Calculates the size of an object or string in bytes. Works with both ASCII
 * and UTF-8 characters to correctly calculate the number of bytes required to
 * represent the object or string.
 * @param obj - Object or string to be calculated.
 */
const objectSize = (obj) => new TextEncoder().encode(JSON.stringify(obj)).length;
/**
 * Calculates the size of an object or string in Kilobytes.
 * @param obj - Object or string to be calculated.
 * @see objectSize
 */
export const sizeInKb = (obj) => objectSize(obj) / 1024;
/**
 * Calculates the size of an object or string in Megabytes.
 * @param obj - Object or string to be calculated.
 * @see objectSize
 */
export const sizeInMb = (obj) => sizeInKb(obj) / 1024;
export default objectSize;
//# sourceMappingURL=ObjectSize.js.map